export default "__VITE_ASSET__Hsxr8Xh2__"